import { fetchTicketNotifList } from './fetchTicketNotifList';
import { sendSumoLog } from './sumoLogger';
import { updateError } from '../../store';
import { NOTIFICATION_KEYS } from '../../components/NotificationComponents/constants';

export const postTicketNotif = async (token, fullNotifBody, dispatch) => {
  const requestUrl = encodeURI(
    `https://${process.env.REACT_APP_API_SUBDOMAIN}.pge-811.com/ticket-notification/notification`
  );
  const headers = new Headers({
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  });

  try {
    const data = await fetch(requestUrl, {
      method: 'POST',
      headers,
      body: JSON.stringify(fullNotifBody),
    });
    const body = await data.json();

    if (!data.ok) {
      throw {
        message: `Failed to create ticket notification ${
          fullNotifBody[NOTIFICATION_KEYS.NAME]
        } with status: ${data.status} and message: ${body.message}`,
        code: data.status,
      };
    }

    fetchTicketNotifList(token, dispatch);
  } catch (error) {
    const isInternalError = error instanceof Error;
    const errorMessage = isInternalError ? error.toString() : error.message;
    sendSumoLog(
      'postTicketNotif',
      errorMessage,
      isInternalError ? 500 : error.code,
      dispatch,
      false
    );
    updateError(error, dispatch);
  }
};
